// 1. Imports
import { Container, Stack } from "@mui/material";
import { Page } from "../../../../components";
import HeaderBreadcrumbs from "../../../../components/header-breadcrumbs";
import { RecipientsComponentV2 } from "../../../../components/message-center/v2/recipients-v2/recipients-component-v2";

// 2. Component Def
export const AutomatedReminderRecipientsScreen = () => {
    return (
        <Page title="POM Safe - Select Recipients">
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <HeaderBreadcrumbs
                        heading="New automated reminder"
                        links={[
                            { name: 'Message Center', href: '/messages' },
                            { name: 'Select Recipients', href: '/messages/automated-reminders/recipients' },
                        ]}
                        activeLast={false}
                    />
                </Stack>

                <RecipientsComponentV2 mode="reminder" />
            </Container>
        </Page>
    )
}